<template>
	<div class="daili">
		<div class="tupian">
	   <img src="../assets/img/QQ图片20200821144435.jpg" />
		</div>
		<div class="neirong">
			<div class="neirong-a">
				<div class="title-a">
					<p class="title-a-1">方式一：电话咨询</p>
				</div>
			<p class="aa">{{$route.name.daili}}</p>
			 <p class="bb">联系电话：{{$route.name.phone}}</p>
			 <div class="weixin">
			    {{$route.name.wechat}}
			 </div>
	           <div class="cc">
			 	<a @click="zixun" class="cc-1" :href="'tel:' + $route.name.phone">
			 		<button ><i class="iconfont icon-lijizixun"></i>立即咨询</button></a>
			 		</div>
			</div>
			<div class="xx">
		<div class="xinxi">
			   <div class="title-b">
					<p class="title-b-1">方式二：填写您的个人信息，专业老师将主动联系您</p>
				</div>
			   <div class="form">
			   	<label>手机号码：</label>
			   	<input type="text" v-model="phone"    @blur="animate()" placeholder="请输入您的手机号码" />
			   </div>
			   <div class="form-a">
			   	<label>报考科目：</label>
			   	<input type="text" v-model="kmmc" placeholder="请输入您的报考专业科目" />
			   </div>
			   <button class="btn" @click="submit">
			   	<i class="iconfont icon-tijiao"></i>提交
			   </button>
		</div>
		</div>
		</div>
	</div>
</template>

<script>
	var that;
	import Api from "../assets/js/api.js";
	export default {
  data() {
    return {
      phone:"",
      kmmc:""
    };
  },
  mounted() {
  	that=this;
  },
  methods: {
	 animate(){
           var re = /^1\d{10}$/;
           let str = this.phone;
           if(re.test(str)){
              
           }else {
          this.$toast('请填写正确电话号码');
          }
       },
    onSubmit(values) {
      console.log('submit', values);
    },
	zixun(){
		that.$http({
			url:Api.insertBuriedPoint,
			method:"POST",
			data:{
				slbs:that.$route.fullPath,
				khzx:1
			}
		}).then(res=>{
			console.log(res)
		})
	},
    submit(){
    	this.$http({
    		url:Api.insertUser,
    		 method: "POST", //请求方式 默认get
          data:{
          	phone:this.phone,
          	kmmc:this.kmmc,
          	gys_name:this.$route.name.daili,
          	gys_code:this.$route.fullPath,
			client_type:this.$route.name.origin
			
          }
    	}).then(res=>{
    		if (res.data.success == true){
    			console.log(res);
				this.$toast.success('提交成功');
    		}else{
    			return false
    		}
    		 
    	})
    }
  }
};
</script>

<style>
	.tupian{
		width: 100%;
	}
	.tupian img{
		width: 100%;
	}
	.neirong-a{
		width: 85%;
		height: 210px;
		margin: 0 auto;
		margin-top: 20px;
	    box-shadow: #DCDCDC 0px 0px 5px;
	}
	.title-a{
		height: 40px;
		border-bottom: 1px solid #DCDCDC;
	}
	.title-a-1{
		line-height: 40px;
		font-size: 12px;
		font-weight: bold;
		padding-left: 8px;
	}
	.xx{
		display: flex;
		justify-content: center;
	}
	.xinxi{
		width: 85%;
		height: 245px;
		margin-top: 20px;
		margin-bottom: 20px;
		box-shadow: #DCDCDC 0px 0px 5px;
	}
	.title-b{
		margin-top: -10px;
		height: 40px;
		border-bottom: 1px solid #DCDCDC;
	}
	.title-b-1{
		line-height: 40px;
		font-size: 12px;
		font-weight: bold;
		padding-left: 18px;
	}
	.neirong-a p{
     margin-left: 10px;
	}
	.aa{
		font-size: 20px;
		font-weight: 700;
	}
	.bb{
		font-weight: 700;
	}
	.weixin{
		width: 85%;
		height: 15px;
		/*border: 1px solid red;*/
		margin-left: 10px;
		font-weight: 700;
	}
	.bb .bb-1{
		color: black;
	}
	.icon-lijizixun:before {
    content: "\e600";
    font-size: 20px;
    display: inline;
      }

	.cc button{
		width: 110px;
		height: 30px;
		border: none;
		margin-left: 8px;
		border-radius: 20px;
		font-size: 15px;
		color: #ffffff;
		display: flex;
		text-align: center;
		float: right;
		margin-right: 10px;
		/*margin-top: -10px;*/
		align-items: center;
		padding-left: 12px;
		background:linear-gradient(to right, #ff8e01 , #ffb300);
	}
	.form{
		width: 90%;
		height: 40px;
		margin: auto;
		margin-top: 30px;
		/*border: 1px solid red;*/
		display: flex;
		align-items: center;
	}
	.form label{
		font-size: 20px;
		font-weight: bold;
	}
	.form input{
		width: 170px;
		height: 30px;
		border: none;
		border-bottom:1px solid #CACACA ;
	}
	input::-webkit-input-placeholder {
		font-size: 15px;
		color: #CACACA;
	}
	.form-a{
		width: 90%;
		height: 40px;
		margin: auto;
		margin-top: 20px;
		/*border: 1px solid red;*/
		display: flex;
		align-items: center;
	}
	.form-a label{
		font-size: 20px;
		font-weight: bold;
	}
	.form-a input{
		width: 170px;
		height: 30px;
		border: none;
		border-bottom:1px solid #CACACA ;
	}
	.btn{
		width: 110px;
		height: 30px;
		border: none;
		margin-left: 8px;
		border-radius: 20px;
		font-size: 15px;
		color: #ffffff;
		display: flex;
		align-items: center;
		padding-left: 25px;
		float: right;
		margin-top: 20px;
		margin-right: 10px;
		background:linear-gradient(to right, #ff8e01 , #ffb300);
	}
</style>